const ITEMS = ["Conteúdo exclusivo", "Somente maiores de 18", "Vídeos em alta definição", "Ensaios fotográficos", "Atualização constante", "Acesso livre e discreto"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="marquee-wrap relative overflow-hidden border-y border-rose-900/30 bg-[#0b0a0e] py-6" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className={`font-serif-d px-8 text-2xl sm:text-4xl ${i % 2 ? "italic text-rose-400/90" : "text-slate-200"}`}>{t}</span>
                <span className="h-2 w-2 rotate-45 bg-rose-600" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
